import { Component, Input, OnChanges } from '@angular/core';
import { ColumnDef } from '../../../shared/data-table/data-table.model';
import { CohortProgressRow } from '../../../_models/reports/cohort-progress-row.model';

type CohortProgressTableRow = CohortProgressRow & { studentName: string };

@Component({
    selector: 'cohort-progress-report',
    templateUrl: 'cohort-progress-report.component.html',
    styleUrls: ['cohort-progress-report.component.css'],
    standalone: false
})
export class CohortProgressReportComponent implements OnChanges {

    @Input() rows: CohortProgressRow[];

    public columns: ColumnDef<CohortProgressTableRow>[] = [
        { field: 'studentName', header: 'Learner', type: 'template', templateName: 'studentName', sortable: true },
        { field: 'clientName', header: 'Client', sortable: true },
        { field: 'outcomeDate', header: 'Date', type: 'date', sortable: true },
        { field: 'keyStage', header: 'Key Stage', sortable: true },
        { field: 'learningBand', header: 'Learning Band', sortable: true },
        { field: 'value', header: 'Value', sortable: true },
        { field: 'month', header: 'Month', sortable: true }
    ];

    public tableRows: CohortProgressTableRow[] = [];

    ngOnChanges(): void {
        const source = this.rows != null ? this.rows : [];
        // Derive a sort key so the shared table sorts the Learner column by
        // last name then first name, matching the previous sortingDataAccessor.
        this.tableRows = source.map(row => ({
            ...row,
            studentName: (row.studentLastName + ' ' + row.studentFirstName).toLowerCase()
        }));
    }
}
